import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonRouterOutlet,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import PhoneRegister from "./pages/register/PhoneRegister";
import BoxIndex from "./pages/blindbox/BoxIndex";
import BoxPrize from "./pages/blindbox/BoxPrize";
import React from "react";
import PhoneAccountRefund from "./pages/member/refund/PhoneAccountRefund";
import PhoneAccountRefundCheck from "./pages/member/refund/PhoneAccountRefundCheck";
import PhoneCancellationAccount from "./pages/member/client/PhoneCancellationAccount";

import PhoneIndex from "./pages/member/kefu/phone/Index";
import PhoneBind from "./pages/member/kefu/phone/PhoneBind";
import ChangePassword from "./pages/member/kefu/phone/ChangePassword";
import AccountLost from "./pages/member/kefu/phone/AccountLost";
import AccountAppeal from "./pages/member/kefu/phone/AccountAppeal";
import AccountCancellation from "./pages/member/kefu/phone/AccountCancellation";
import AccountCancellationRepeal from "./pages/member/kefu/phone/AccountCancellationRepeal";
import RealNameAuthen from "./pages/member/kefu/phone/RealNameAuthen";
import RechargeRecord from "./pages/member/kefu/phone/RechargeRecord";
import AccountBind from "./pages/member/kefu/phone/AccountBind";
import AppealProgress from "./pages/member/kefu/phone/AppealProgress";
import PhoneAccountTheft from "./pages/member/kefu/phone/AccountTheft";
import GameException from "./pages/member/kefu/phone/GameException";
import PhoneSuggest from "./pages/member/kefu/phone/PhoneSuggest";
import RefundTutelage from "./pages/member/kefu/phone/RefundTutelage";
import RefundFlow from "./pages/member/kefu/phone/RefundFlow";
import PhoneBadInformation from "./pages/member/kefu/phone/PhoneBadInformation";
import AccountDeny from "./pages/member/kefu/phone/AccountDeny";
import RemoveBind from "./pages/member/kefu/phone/RemoveBind";
import MPay from "./pages/pay/MPay";
import PhoneLogin from "./pages/login/PhoneLogin";
import AliPayJump from "./pages/pay/AliPayJump";
import PayResult from "./pages/pay/PayResult";
import Index from "./pages/index/Index";
import H5Pay from "./pages/pay/H5Pay";

import ClientPhoneBind from "./pages/member/client/PhoneBind";
import RearUserInfo from "./pages/member/client/RearUserInfo";
import AppleCancellationAccount from './pages/member/client/AppleCancellationAccount';

setupIonicReact();


const App: React.FC = () => (
    <IonApp>
      <IonReactRouter>
          <IonRouterOutlet placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <Route exact path="/index">
                  <Index />
              </Route>
              <Route exact path="/">
                  <Redirect to="/index" />
              </Route>
              <Route path="/boxIndex">
                  <BoxIndex />
              </Route>
              <Route path="/boxPrize">
                  <BoxPrize />
              </Route>
              <Route path="/h5register">
                  <PhoneRegister />
              </Route>
              <Route path="/h5accountRefund">
                  <PhoneAccountRefund />
              </Route>
              <Route path="/h5accountRefundCheck">
                  <PhoneAccountRefundCheck />
              </Route>
              <Route path="/h5cancellationAccount">
                  <PhoneCancellationAccount />
              </Route>
              <Route path="/client/phoneBind">
                  <ClientPhoneBind /></Route>
            <Route path="/client/RearUserInfo">
                  <RearUserInfo /></Route>
              <Route path="/phone/index">
                  <PhoneIndex />
              </Route>
              <Route path="/phone/phoneBind">
                  <PhoneBind />
              </Route>
              <Route path="/phone/changePassword">
                  <ChangePassword />
              </Route>
              <Route path="/phone/accountLost">
                  <AccountLost />
              </Route>
              <Route path="/phone/accountAppeal">
                  <AccountAppeal />
              </Route>
              <Route path="/phone/accountCancellation">
                  <AccountCancellation />
              </Route>
              <Route path="/phone/accountCancellationRepeal">
                  <AccountCancellationRepeal />
              </Route>
              <Route path="/phone/realNameAuthen">
                  <RealNameAuthen />
              </Route>
              <Route path="/phone/rechargeRecord">
                  <RechargeRecord />
              </Route>
              <Route path="/phone/accountBind">
                  <AccountBind />
              </Route>
              <Route path="/phone/appealProgress">
                  <AppealProgress />
              </Route>
              <Route path="/phone/accountTheft">
                  <PhoneAccountTheft />
              </Route>
              <Route path="/phone/gameException">
                  <GameException />
              </Route>
              <Route path="/phone/suggest">
                  <PhoneSuggest />
              </Route>
              <Route path="/phone/refundTutelage">
                  <RefundTutelage />
              </Route>
              <Route path="/phone/refundFlow">
                  <RefundFlow />
              </Route>
              <Route path="/phone/badInformation">
                  <PhoneBadInformation />
              </Route>
              <Route path="/accountDeny">
                  <AccountDeny />
              </Route>
              <Route path="/removeBind">
                  <RemoveBind />
              </Route>
              <Route path="/mPay">
                  <MPay />
              </Route>
              <Route path="/h5Login">
                  <PhoneLogin />
              </Route>
              <Route path="/aliPayJump">
                  <AliPayJump />
              </Route>
              <Route path="/payResult">
                  <PayResult />
              </Route>
              <Route path="/H5/ClientDo.aspx">
                  <H5Pay />
              </Route>
              <Route path="/applecancellationAccount">
                  <AppleCancellationAccount />
              </Route>
          </IonRouterOutlet>

      </IonReactRouter>
    </IonApp>
);

export default App;
